
import React from 'react';
import { Table, Column, Cell, ColumnGroup } from 'fixed-data-table-2';
import { Checkbox, Pagination, Select,Tabs } from 'antd';
import Row from '../basic/row';
import Col from '../basic/col';
import CellModel from './CellModel';
import SvgIcon from 'SvgIcon';
import { getPredicateValue, getRoundValue, getMultiplication, getNidAndUitype } from '../../helpers/util'
const TabPane = Tabs.TabPane;
export default class TableTouch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      readOnly: true,//是否只读
      visible: false,
      pagination: { total: 0, current: 0, pageSize: 0 },
      sumData: [],//合计数据
      style: props.style,
      gridWidth: props.width || 1100,
      openContentHeight: props.openContentHeight || false, // 是否开启根据表格内容计算row高度  默认不开启 兼容从设计器cStyle传递过来的openContentHeight属性
      chooseTableMode: 'list', // 磁贴表格默认显示
    };
    // showCheckBox 是否显示选择框  showRowNo 是否显示行号
    //是否单选 isPagination 是否分页
    this.GridProps = {
      showRowNo: true,
      showCheckBox: false,
      isPagination: false,
    };
    this.allSelect = false;
    this.dataList = [];/*grid数据*/
    this.columns = {};/*grid栏目数据*/
    this.ColIndexs = {};/*key与number对照*/
    this.selectIndex = -1;/*选择行index*/
    this.scrollCol = null;
    this.scrollRow = 0;
    this.headerHeight = 46;
    this.actionState = [];
    this.CellState = [];/*单元格状态 disabled readnonly style*/
    this.isColErro = [];
    this.action = {};/*操作列渲染数据*/
    this.actionStyle = {};
    this.RowCol = {};/*记录RowColChange改变前数据*/
    this.renderIndex = 1;
    this.rowheight = props.rowHeight || 56;
    this.showRows = 0;
    this.__isElectronic = false;
    this.bodyHeight = 0;
    this.rowStatus = [];/*行状态*/
    this.contentHeight = []; // 根据表格内容计算row高度
    this.rowContentHeight = {}; // 根据表格内容计算row高度
    this.CompositeLayout = [];
    this.nidAnduitype = getNidAndUitype(props);
  }

  componentDidMount() {
    if (window.__isElectronic || window.__isIpad) {
      this.__isElectronic = true;
      if (this.props.rowHeight)
        this.rowheight = this.props.rowHeight;
      else
        this.rowheight = 46;
      this.headerHeight = 40;
    }

    if (this.props.model) {
      this.props.model.addListener(this);
      /*表格高度*/
      let scrollXWidth = (this.totalWidth > (this.props.width || 1100) ? 17 : 2);
      let height = this.props.height ? this.props.height : 1020;
      let bodyHeight = height - this.headerHeight - scrollXWidth;
      let pageIndex = Math.ceil(bodyHeight / this.rowheight / 10);
      if (this.__isElectronic && this.props.tableMode == 'refer') {
        this.showRows = Math.ceil(bodyHeight / this.rowheight);
        this.props.model.setPageSize(10);
      } else {
        this.showRows = Math.ceil(bodyHeight / this.rowheight);
        // Math.floor(bodyHeight / this.rowheight)
        let pageSize = pageIndex * 10;
        this.props.model.setPageSize(pageSize);
      }
      if (this.__isElectronic && this.props.tableMode == 'refer') {
        this.bodyHeight = height - this.headerHeight - scrollXWidth;
      }
    }
    let clientWidth = document.documentElement.clientWidth;
    if (clientWidth < 1024 && clientWidth == this.state.gridWidth) {
      this.setState({ gridWidth: this.state.gridWidth - 20 })
    }
    const uuid = new Date().valueOf() + '|' + (this.props && this.props.meta && this.props.meta.groupId || '');
    this.tableGuid = uuid;
    // 卡片式导航
    if (this.state.style && this.state.style.cardNav) {
      this.setChooseTable(false)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (!cb.utils.isEmpty(nextProps.width) && this.state.gridWidth != nextProps.width) this.setState({ gridWidth: nextProps.width });
    if (this.props.height != nextProps.height) {
      if (nextProps.model && this.__isElectronic && this.props.tableMode == 'refer') {
        let scrollXWidth = (this.totalWidth > (this.props.width || 1100) ? 17 : 2);
        let height = nextProps.height ? nextProps.height : 1020;
        this.bodyHeight = height - this.headerHeight - scrollXWidth;
      }
    }
    if (nextProps.width !== 0 && nextProps.width !== this.props.width && this.tableCardCont) {
      this.setTableCardCols()
    }
  }
  componentDidUpdate() {
    if (this.props.model) {
      this.props.model.addListener(this);
      let scrollXWidth = (this.totalWidth > (this.props.width || 1100) ? 17 : 2);
      let gridHeight = this.getGridHeight();
      let bodyHeight = gridHeight - scrollXWidth;
      this.showRows = Math.ceil(bodyHeight / this.rowheight);
    }
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }

  rowClassNameGetter = (index) => {
    if (this.rowStatus[index] && this.rowStatus[index].disabled && this.rowStatus[index].disabled != undefined) {
      return 'public_fixedDataTableRow_disabled';
    }
    if (this.rowStatus[index] && this.rowStatus[index].className && this.rowStatus[index].disabled != undefined) {
      return 'public_fixedDataTableRow_' + this.rowStatus[index].className;
    }
    if (this.GridProps.showCheckBox) {
      if (this.props.model) {
        let selectRows = this.props.model.getSelectedRowIndexes();
        let keyboardIndex = this.props.model._get_data('keyboardIndex');
        keyboardIndex = keyboardIndex === undefined ? -1 : keyboardIndex;
        let _class = '';
        if (keyboardIndex >= 0 && keyboardIndex == index) {
          _class += ' public_fixedDataTableRow_preFocusedRow';
        }
        for (var i = 0; i < selectRows.length; i++) {
          let rowIndex = selectRows[i];
          if (index === rowIndex)
            _class += ' public_fixedDataTableRow_CheckedRow';
        }
        if (_class) return _class
      }
    } else {
      if (index === this.selectIndex)
        return 'public_fixedDataTableRow_selected';
    }
  }

  //-----------------------------------------------------------设置grid中columns，datasource等属性--------------------------------------------------------------------------------------------------
  setListenerState = (params) => {
    // if (params.columnMode === 'local' && this.props.columns) {
    //   for (var attr in this.props.columns)
    //     Object.assign(this.props.columns[attr], params.columns[attr]);
    //   params.columns = this.props.columns;
    // }
    if (params.columnMode === 'local' && this.props.columns) {
      const columns = {}, fieldNames = [];
      for (var attr in this.props.columns) {
        fieldNames.push(attr);
        const modelColumn = params.columns[attr];
        if (!modelColumn) continue;
        const viewColumn = this.props.columns[attr];
        modelColumn.index = viewColumn.index;
        modelColumn.enterDirection = viewColumn.enterDirection;
        modelColumn.relatedActions = viewColumn.relatedActions;
        const column = {};
        Object.assign(column, viewColumn, modelColumn);
        columns[attr] = column;
      }
      params.columns = columns;
      this.props.model._set_data('fieldNames', fieldNames);
    }
    let tmp_ColIndexs = {};
    let index = 0;
    /*cellState*/
    if (params.cellState) {
      this.cellState = params.cellState;
    }


    //栏目col与index对照
    var hasColumn = false;
    let tableWidth = this.props.width || 1100;
    for (var attr in params.columns) {
      if (this.props.widthMode == 'percent') {
        let iColWidth = parseFloat(params.columns[attr].iColWidth);
        let width = isNaN(iColWidth) ? 25 : iColWidth;
        width = tableWidth * width / 100;
        params.columns[attr].iColWidth = width;
      } else {
        if (isNaN(params.columns[attr].iColWidth)) {
          params.columns[attr].iColWidth = 200;
        } else {
          if (this.state.style && !cb.utils.isEmpty(this.state.style.recalcWidth) && this.state.style.recalcWidth == false)
            params.columns[attr].iColWidth = parseFloat(params.columns[attr].iColWidth);
          else
            params.columns[attr].iColWidth = parseFloat(params.columns[attr].iColWidth * 4 / 3);
        }
      }
      hasColumn = true;
      if (index === 0) {
        tmp_ColIndexs[attr] = 0;
      } else {
        tmp_ColIndexs[attr] = index;
      }
      index = index + 1;
    }
    if (params.pageInfo) {
      this.setPageInfo(params.pageInfo);
    }
    this.colsWidth = this.computeColsWidth(params.columns);
    this.GridProps.showRowNo = params.showRowNo;//是否显示行号
    this.GridProps.showCheckBox = params.showCheckBox;//是否显示复选框
    this.GridProps.isRadio = !params.multiple;//是否单选
    this.GridProps.showAggregates = params.showAggregates;//是否显示合计
    this.GridProps.showSubtotal = params.showSubtotal;//是否显示小计
    this.GridProps.isPagination = params.pagination;//是否分页
    this.GridProps.showColumnSetting = params.showColumnSetting;//是否显示栏目设置
    this.ColIndexs = tmp_ColIndexs;//栏目与index对照

    if (hasColumn) {
      this.columns = params.columns;
      if (params.rows && params.rows.length > 0)
        this.dataList = params.rows;
      //初始化单元格状态
      this._InitCellStatus(params.columns, params.rows);
      this.readOnly = params.readOnly;
      let columnset = this.RemodelingColumn(params.rows, params.columns);
      this.setState({
        readOnly: params.readOnly,
        columnset,
        showColumnSetting: params.showColumnSetting
      });
    }
  }

  //初始化单元格状态
  _InitCellStatus = (Columns, DataSource) => {
    /*初始化action列的渲染数据*/
    let action = this.props.action;
    if (action && action.cControlType && action.cControlType == 'Toolbar') {
      this.action = action;
      let cStyle = action.cStyle;
      try {
        if (!cStyle || cStyle == '') {
          cStyle = {};
        } else {
          cStyle = JSON.parse(cStyle);
        }
      } catch (e) {
        cb.utils.alert('Toolbar cStyle，预制错误！', 'error');
      }
      this.fixedwidth = cStyle.fixedwidth;
    }
    if (DataSource !== undefined) {
      //设置初始单元格编辑状态/行选择初始状态/action状态/单元格状态 disabled/readOnly/style
      let temp_cellState = cb.utils.extend(true, [], this.cellState);
      let temp_isColErro = cb.utils.extend(true, [], this.isColErro);
      let temp_actionState = cb.utils.extend(true, [], this.actionState);
      let temp_rowStatus = cb.utils.extend(true, [], this.rowStatus);
      const temp_CompositeLayout = cb.utils.extend(true, [], this.CompositeLayout);// 组合控件布局
      let length = DataSource.length;
      if (length <= 0) return;
      for (let i = 0; i < length; i++) {
        DataSource[i]._selected = false;
        if (!temp_rowStatus[i]) temp_rowStatus[i] = { disabled: false, visible: false };
        if (this.action && this.action.controls) {
          let actionList = this.action.controls;
          if (!temp_actionState[i])
            temp_actionState[i] = {};
          actionList.map(function (action) {
            if (!temp_actionState[i][action.cItemName])
              temp_actionState[i][action.cItemName] = { disabled: false, visible: true };
          });
        }
        if (!temp_cellState[i])
          temp_cellState[i] = {};
        if (!temp_isColErro[i])
          temp_isColErro[i] = {};
        if (!temp_CompositeLayout[i])
          temp_CompositeLayout[i] = {};
        for (var attr in Columns) {
          if (!temp_cellState[i][attr])
            temp_cellState[i][attr] = { disabled: false, visible: false, readOnly: false, style: {} };
          if (!temp_isColErro[i][attr])
            temp_isColErro[i][attr] = false;
          if (Columns[attr].cControlType == 'composite') {
            const compositeLayout = Columns[attr].compositeLayout
            if (compositeLayout) temp_CompositeLayout[i][attr] = typeof compositeLayout === 'string' ? cb.utils.jsonParse(compositeLayout) : compositeLayout;
          }
        }
      }
      if (temp_actionState) this.actionState = temp_actionState;
      if (this.props.model) this.props.model.initActionsState(this.actionState);
      this.cellState = temp_cellState;
      this.rowStatus = temp_rowStatus;
      this.isColErro = temp_isColErro;
      this.CompositeLayout = temp_CompositeLayout;
    }
  }
  //----------------------------------------------接受viewmodeld参数-----------------------------------------------------------------------------------------------
  //接受来自model的column信息
  setColumns = (columns) => {
    let columndata = cb.utils.extend(true, {}, columns)
    if (this.props.widthMode == 'percent') {
      let tableWidth = this.props.width || 1100;
      for (var key in columndata) {
        let iColWidth = parseFloat(columndata[key].iColWidth);
        let width = isNaN(iColWidth) ? 25 : iColWidth;
        width = tableWidth * width / 100;
        columndata[key].iColWidth = width;
      }
    } else {
      for (var attr in columndata) {
        if (isNaN(columndata[attr].iColWidth)) {
          columndata[attr].iColWidth = 200;
        } else {
          columndata[attr].iColWidth = parseFloat(columndata[attr].iColWidth * 4 / 3);
        }
      }
    }
    this.colsWidth = this.computeColsWidth(columndata);
    let columnset = this.RemodelingColumn(this.dataList, columndata);
    this.columns = columndata;
    let length = this.dataList.length;
    for (let i = 0; i < length; i++) {
      for (var attr in columndata) {
        if (!this.cellState[i][attr]) {
          this.cellState[i][attr] = { disabled: false, visible: false, readOnly: false, style: {} };
        }
      }
    }
    this.setState({ columnset });
  }
  computeColsWidth = (columns) => {
    let colsWidth = 0;
    for (var key in columns) {
      let iColWidth = parseFloat(columns[key].iColWidth || 200);
      colsWidth += iColWidth;
    }
    return colsWidth;
  }
  setSum = (sumData) => {
    // if (sumData.length > 0)
    this.setState({
      sumData
    })
  }

  //接收来自model的data信息
  setDataSource = (data) => {
    this.selectIndex = -1;
    this.dataList = data;
    this.indeterminate = false;
    this.allSelect = false;
    /*设置scrollRow--滚动加载*/
    let { current, pageSize } = this.state.pagination;
    if (data.length <= pageSize || pageSize == -1) {
      this.scrollRow = 0;
    } else {
      this.scrollRow = current * 10;
    }

    //初始化单元格状态
    this._InitCellStatus(this.columns, data);
    let columnset = this.RemodelingColumn(data, this.columns);
    this.setState({ columnset });
    if (this.props.onChangeData)
      this.props.onChangeData();
  }

  // 设置快捷键聚焦行
  setKeyboardIndex = (value, name) => {
    this.scrollRow = value
  }

  //---------------------------------------------组织grid结构----------------------------------------------------------------------------------------------------------------
  //组织column结构
  RemodelingColumn = (dataList, columnState) => {
    let ret = [], columnData = [], actionAlign = '', Operation = {};
    let isGroup = false;/*是否多表头*/
    for (var attr in columnState) {
      if (columnState[attr].parent) {
        isGroup = true;
        break;
      }
    }
    const readOnly = this.readOnly;
    /*操作列*/
    if (this.action.controls) {
      columnState.Operation = { 'cItemName': 'Operation', 'iColWidth': 70, 'cShowCaption': '操作', 'cControlType': 'Action', 'iAlign': 3 };
      if (this.fixedwidth) columnState.Operation.iColWidth = this.fixedwidth;
      columnData.push(columnState.Operation);
    }
    /*行号*/
    if (this.GridProps.showRowNo) {
      if (!columnState.GridRowNo)
        columnState.GridRowNo = { 'cItemName': 'GridRowNo', 'iColWidth': 50, 'cControlType': 'Input', 'bFixed': '1' };
      columnData.push(columnState.GridRowNo);
    }
    /*选择列*/
    if (this.GridProps.showCheckBox || this.props.hasAction) {
      if (!columnState.CheckBox)
        columnState.CheckBox = { 'cItemName': 'CheckBox', 'iColWidth': 45, 'cControlType': 'SelectCheckBox' };
      columnData.push(columnState.CheckBox);
    }

    for (var attr in columnState) {
      if (attr != 'CheckBox' && attr != 'GridRowNo' && attr != 'Operation')
        columnData.push(columnState[attr]);
    }
    if (isGroup ) 
      return this.RemodelingGroupColumn(dataList, columnState);
    this.totalWidth = 0;
    columnData.map(function (col) {
      let column = this.setColumn(col.cItemName, col);
      this.totalWidth += col.iColWidth;
      ret.push(column);
    }, this);
    return ret;
  }

  /*多表头*/
  RemodelingGroupColumn = (dataList, columnState) => {

    /*行号*/
    // columnState.GridRowNo = { 'cFieldName': 'GridRowNo', 'cItemName': 'GridRowNo', 'iColWidth': 30, 'cControlType': 'Input' };

    let cols = {};
    let columns = cb.utils.extend(true, {}, columnState);
    this.totalWidth = 0;
    for (var key in columns) {
      let item = columns[key];//栏目属性对象
      item.iColWidth = item.iColWidth ? parseFloat(item.iColWidth) : 200;
      if (!item.parent) {
        cols[item.cItemName] = item;
      } else {
        this.loopColumn(item.parent, cols, item);
      }
      this.totalWidth += item.iColWidth;
    }
    return this.restructureColumn(dataList, cols);
  }
  /*组织多表头栏目*/
  restructureColumn = (dataList, columns) => {
    let col = [];
    for (var key in columns) {
      let item = columns[key];//栏目属性对象
      if (item.children) {
        let children = this.loopChildren(item);
        let header = this.getGroupHeader(item);
        col.push(
          <ColumnGroup key={item.cFieldName} header={header}>
            {children}
          </ColumnGroup>
        );
      } else {
        let column = this.setColumn(item.cItemName, item);
        let fixed = false;
        if (item.cItemName == 'CheckBox' || item.cItemName == 'GridRowNo') fixed = true;
        col.push(
          <ColumnGroup fixed={fixed} key={item.cFieldName} header={<Cell><div className='headerName' style={{ "height": this.headerHeight }}></div></Cell>}>
            {column}
          </ColumnGroup>
        )
      }
    }
    return col;
  }
  /*组织多表头显示组件*/
  getGroupHeader = (item) => {
    let header = [];
    header.push(
      <Row className="group-row" style={{ "height": (this.headerHeight || 40) }}>
        <div className="group-col" style={{ "height": (this.headerHeight || 40) }}>{item.cShowCaption}</div>
      </Row>
    )
    let headerRow = this.getHeaderRow(item.children);
    if (headerRow.length > 0) {
      let i = 1;
      headerRow.map(row => {
        header.push(
          <Row className="group-row" style={{ "height": (this.headerHeight || 40) }}>{row}</Row>
        )
        i += 1;
      });
      this.groupHeaderHeight = i * (this.headerHeight || 40) + 1;
    } else {
      this.groupHeaderHeight = (this.headerHeight || 40) + 1;
    }
    let rowWidth = this.getGroupHeaderWidth(item.children);
    return <div className="table-group-header" style={{ "width": rowWidth }}>{header}</div>
  }
  /*组织多表头的行表头*/
  getHeaderRow = (children) => {
    let headerRows = [], headerRow = [];
    children.map(col => {
      if (col.children) {
        var width = this.getGroupHeaderWidth(col.children);
        col.iColWidth = width;
        headerRow.push(
          <div className="group-col" style={{ "height": (this.headerHeight || 40), "width": width }}>{col.cShowCaption}</div>
        )
        if (col.children[0].children) {
          let newRow = this.getHeaderRow(col.children);
          headerRows[headerRows.length] = newRow;
        }
      }
    });
    if (headerRow.length > 0)
      headerRows[headerRows.length] = headerRow;
    return headerRows;
  }
  /*获取多表头宽度*/
  getGroupHeaderWidth = (item) => {
    var width = 0;
    item.map(col => {
      let w = this.loopHeader(col, width);
      width += w;
    });
    return width;
  }
  loopHeader = (item) => {
    let children = item.children;
    let width = 0;
    if (children) {
      children.map(col => {
        if (col.iColWidth) {
          width += col.iColWidth;
        } else {
          width += this.loopHeader(col);
        }
      });
    } else {
      width = item.iColWidth ? item.iColWidth : 200;
    }
    return width;
  }
  loopChildren = (item) => {
    let col = [];
    item.children.forEach(function (ele) {
      if (ele.children) {
        let children = this.loopChildren(ele);
        col = col.concat(children);
      } else {
        let column = this.setColumn(ele.cItemName, ele);
        col.push(column)
      }
    }, this);

    return col;
  }
  loopColumn = (data, cols, item, child) => {
    if (!data.parent) {
      if (!cols[data.cFieldName]) {
        cols[data.cFieldName] = data;
        cols[data.cFieldName].children = [];
      }
      if (child && child.parent) delete child.parent;
      let colsChild = cols[data.cFieldName].children;
      let existChild = false, existIndex = 0;
      colsChild.forEach(function (ele, index) {
        if (ele.cFieldName == item.cFieldName) {
          existIndex = index;
          existChild = true;
        }
      }, this);

      if (existChild) {
        cols[data.cFieldName].children[existIndex].children.push(child);
      } else {
        if (child) {
          item.children = [child];
        }
        if (item.parent) delete item.parent;
        cols[data.cFieldName].children.push(item);
      }
    } else {
      this.loopColumn(data.parent, cols, data, item);
    }
  }

  //设置column
  setColumn = (attr, col) => {
    let controlType = col.cControlType;
    var iColWidth = parseFloat(col.iColWidth);
    let width = isNaN(iColWidth) ? 200 : iColWidth;
    let headerCell, headerClassName = '';
    let fiexd = col.bFixed == 1 ? true : false;
    let align = '';
    if (col.iAlign === 1) {
      align = 'left';
    } else if (col.iAlign === 2) {
      align = 'center';
    } else {
      align = 'right';
    }
    if (!col.bCanModify && !this.readOnly) {
      headerClassName = 'public_fixedDataTableCell_disabled';
    } else {
      headerClassName = 'headerName';
    }

    headerCell = (
      <Cell className={headerClassName}>
        <div style={{ textAlign: 'left', width: width, display: "flex" }} id={col.index}>
          <span style={{ width: width }} className="textCol table-header-name">
            {col.cShowCaption}
          </span>
        </div>
      </Cell>
    )
    if (attr === 'Operation') {
      headerCell = (<Cell><div className='headerName'></div></Cell>);
      return (<Column key={attr}
        allowCellsRecycling columnKey={attr}
        header={headerCell} cell={(rowIndex) => this.setCell(rowIndex, col)}
        width={width} align="center" fixedRight={true} footer={this._setFooter} />);
    }
    if (attr === 'CheckBox') {
      let model = this.props.model.getEditRowModel().get(attr);
      if (this.GridProps.isRadio || this.props.hasAction) {
        headerCell = <Cell></Cell>
      } else {
        headerCell = (
          <Cell>
            <div className='checkboxHD'>
              <Checkbox indeterminate={this.indeterminate} checked={this.allSelect} onChange={(e, i) => this.SelectChange(e, -1)}></Checkbox>
            </div>
          </Cell>
        );
      }
      fiexd = true, align = 'center';
    }
    return (<Column key={attr}
      allowCellsRecycling columnKey={attr}
      header={headerCell} cell={(rowIndex) => this.setCell(rowIndex, col)}
      width={width} align={align} fixed={fiexd} footer={this._setFooter} />);
  }
  setColHeight = (rowIndex, height, cItemName, forceUpdate) => {
    if (!this.state.openContentHeight) {
      return
    }
    let preHeight = height;
    if (this.rowContentHeight[rowIndex]) {
      if (this.rowContentHeight[rowIndex][cItemName]) {
        preHeight = this.rowContentHeight[rowIndex][cItemName];
      }
      this.rowContentHeight[rowIndex][cItemName] = height;
    } else {
      this.rowContentHeight[rowIndex] = {
        [cItemName]: height
      };
    }
    const cellsHeightArr = Object.values(this.rowContentHeight[rowIndex]);
    let rowMaxHeight = Math.max(...cellsHeightArr); // 留上下空隙
    if (rowMaxHeight > 188) rowMaxHeight = 188;
    this.contentHeight[rowIndex] = rowMaxHeight;
    this.rowheight = rowMaxHeight
    if (forceUpdate || Math.abs(preHeight - height) > 30) {
      setTimeout(() => {
        this._triggerRender();
      }, 0)
    }
  }
  setCell = (rowIndex, col) => {
    let isColErro = this.isColErro[rowIndex.rowIndex][rowIndex.columnKey] ? this.isColErro[rowIndex.rowIndex][rowIndex.columnKey] : false;
    if (this.state.style && this.state.style.height) {
      this.rowheight = this.state.style.height;
    }
    return (<CellModel
      dataList={this.dataList} 
      hasAction={this.props.hasAction} 
      readOnly={this.readOnly} 
      selectIndex={this.selectIndex} 
      rowStatus={this.rowStatus} 
      RowProperty={rowIndex} 
      selectAllState={this._selectAllState}
      action={this.action} 
      indeterminate={this.indeterminate} 
      selectAll={this.allSelect} 
      cellState={this.cellState} 
      isColErro={isColErro} 
      Column={col} 
      model={this.props.model} 
      GridProps={this.GridProps} 
      triggerRender={this._triggerRender} 
      columnsList={this.columns} 
      rowHeight={this.props.rowHeight || this.rowheight} 
      setCellBlur={this.setCellBlur}
      renderIndex={this.renderIndex} 
      ActionClick={this.ActionClick} 
      rowHeight={this.rowheight} 
      actionState={this.actionState}
      setColHeight={this.setColHeight}
      openContentHeight={this.state.openContentHeight}
      fixedRowHeight={this.rowheight}
      rowContentHeight={this.rowContentHeight || {}}
      CompositeLayout={this.CompositeLayout}
    />);
  }
  _triggerRender = () => {
    var columnset = this.RemodelingColumn(this.dataList, this.columns);
    this.setState({ columnset });
  }

  _selectAllState = (selectAll, indeterminate) => {
    this.allSelect = selectAll;
    this.indeterminate = indeterminate;
    this._triggerRender();
  }
  //监听全选
  SelectChange = (e, index) => {
    if (!e.target.checked) {
      this.props.model.unselectAll();
      this.indeterminate = false;
    } else {
      this.props.model.selectAll();
    }
    this.dataList.map((item, index) => {
      this.dataList[index]._selected = e.target.checked;
    });
    this.allSelect = e.target.checked;
    var columnset = this.RemodelingColumn(this.dataList, this.columns);
    this.setState({ columnset });
  }

  //行单击事件
  _onRowClick = (e, index) => {
    if (this.dataList.length == 0 || !this.dataList[index]) return;
    this.props.model && this.props.model.rowClick && this.props.model.rowClick(index);
    if (this.state.style && this.state.style.cardNav) {
      this.selectIndex = index;
      this.props.model.setCache('navCardActive', index);
      if (this.GridProps.showCheckBox) {
        const indexes = this.props.model.getSelectedRowIndexes();
        const i = indexes.findIndex(function (val) {
          return val == index;
        });
        if (i == -1) {
          this.props.model.select(index, false);
        } else {
          this.props.model.unselect(index)
        }
      } else {
        this.props.model.select(index);
      }
      return
    }
    /*可编辑   多选  rowClick不走select   单选走select*/
    if (!this.state.readOnly) {
      if (this.GridProps.showCheckBox)
        this.props.model.setFocusedRowIndex(index);
      else
        this.props.model.select(index);
      return
    }
    let all = false;
    if (this.GridProps.isRadio || this.props.hasAction) all = true;
    if (all) {
      this.props.model.select(index, all);
    } else {
      let indexes = this.props.model.getSelectedRowIndexes();
      let i = indexes.findIndex(function (val) {
        return val == index;
      });
      if (this.GridProps.showCheckBox)
        all = false;
      else
        all = true;
      if (i == -1)
        this.props.model.select(index, all)
      else
        this.props.model.unselect(index)
    }
  }

  //单元格数据改变事件
  setCellValue = (data) => {
    this.dataList[data.rowIndex][data.cellName] = data.value;
    let columnset = this.RemodelingColumn(this.dataList, this.columns);
    this.setState({ columnset });
  }
  setCellBlur = (data) => {
    if (this._triggerRender)
      this._triggerRender();
  }
  //-------------------------------------------------------------------viewmodel返调用方法------------------------------------------------------------------------------
  select = (indexes) => {
    for (var i = 0; i < this.dataList.length; i++) {
      this.dataList[i]._selected = false;
    }
    for (var attr in indexes) {
      this.dataList[indexes[attr]]._selected = true;
    }
    this.selectIndex = indexes[0] * 1;
    this.scrollRow = indexes[0];
    this._triggerRender();
  }

  unselect = (indexes) => {
    for (var attr in indexes) {
      this.dataList[indexes[attr]]._selected = false;
    }
    this._triggerRender();
  }
  selectAll = () => {
    this.dataList.map((item, index) => {
      this.dataList[index]._selected = true;
    });
    this.allSelect = true;
    this.indeterminate = false;
    this._triggerRender();
  }
  unselectAll = () => {
    this.dataList.map((item, index) => {
      this.dataList[index]._selected = false;
    });
    this.allSelect = false;
    this.indeterminate = false;
    this._triggerRender();
  }
  //model调用  set action列状态
  setActionState = (data) => {
    let actionState = this.actionState;
    actionState[data.rowIndex][data.itemName][data.name] = data.value;
    this._triggerRender();
  }
  setActionsState = (data) => {
    this.actionState = data;
    this._triggerRender();
  }
  //model调用  set行状态
  setRowState = (data) => {
    this.rowStatus[data.rowIndex][data.propertyName] = data.value;
    this._triggerRender();
  }
  setRowStates = (rowStates) => {
    rowStates.forEach(item => {
      this.rowStatus[item.rowIndex][item.propertyName] = item.value;
    });
    this._triggerRender();
  }
  setReadOnly(value) {
    this.readOnly = value;
    this.setState({ readOnly: value });
  }
  //model调用  set单元格状态
  setCellState = (data) => {
    let state = this.cellState;
    if (state[data.rowIndex][data.cellName]) {
      if (state[data.rowIndex][data.cellName][data.propertyName] == data.value) return;
      state[data.rowIndex][data.cellName][data.propertyName] = data.value;
      this._triggerRender();
    }
    //index cellName name value  oldvalue
  }
  //--------------------------------------------------------------------------grid按钮事件------------------------------------------------------------------------------------------------
  //更新行
  updateRow = (data) => {
    this.dataList[data.index] = data.row;
    this._triggerRender();
  }

  //增行
  insertRow = (data) => {
    this.dataList.splice(data.index, 0, data.row);
    //设置新增行单元格初始状态
    this._InitCellStatus(this.columns, this.dataList);
    this.scrollRow = this.dataList.length - 1;
    this._triggerRender();
    this.props.model.select(data.index);
  }
  //批量增行/插行
  insertRows = (data) => {
    if (this.dataList.length == 0) {
      this.setDataSource(data.rows);
    } else {
      for (var i = 0; i < data.rows.length; i++) {
        this.dataList.splice(data.index + i, 0, data.rows[i])
      }
      this._InitCellStatus(this.columns, this.dataList);
      this._triggerRender();
      this.props.model.select(data.index + data.rows.length - 1);
    }
  }
  //删行
  deleteRows = (indexes) => {
    indexes.map(index => {
      this.rowStatus.splice(index, 1);
    });
    this._triggerRender();
  }
  ActionClick = (e, action, index) => {
    let viewModel = this.props.model.getParent();
    while (viewModel.getParent())
      viewModel = viewModel.getParent();
    let params = { index: index, cItemName: action.cItemName }
    viewModel.get(action.cItemName).fireEvent('click', params);
  }
  validate = (val) => {
    if (val.type == 'error') {
      if (val.data) {
        let isColErro = this.isColErro;
        isColErro.map(function (item) {
          for (var key in item) {
            item[key] = false;
          }
        });
        val.data.map(function (item) {
          if (isColErro[item.rowIndex][item.cellName] != undefined && isColErro[item.rowIndex][item.cellName] != 'undefined')
            isColErro[item.rowIndex][item.cellName] = true;
          // Message.error('表体存在必输项，请输入完整在尝试保存！');
          // cb.utils.alert('表体存在必输项，请输入完整在尝试保存！', 'error');
        });
        this._triggerRender();
        cb.utils.alert('表体存在必输项，请输入完整再尝试保存！', 'error');
      } else {
        cb.utils.alert('表体数据为空！不允许保存！', 'error');
      }
    }
  }
  //---------------------------------------------------------------------------------分页相关-----------------------------------------------------------------------------------
  //设置分页
  setPageInfo = (paginationlist) => {
    if (paginationlist.pageSize === -1)
      this.GridProps.isPagination = false;
    var pageinfo = this.state.pagination;
    pageinfo.total = paginationlist.recordCount
    pageinfo.current = paginationlist.pageIndex;
    pageinfo.pageSize = paginationlist.pageSize;
    /*设置scrollRow--滚动加载*/
    let { current, pageSize } = pageinfo;
    if (this.dataList.length <= pageSize || pageSize == -1) {
      this.scrollRow = 0;
    } else {
      this.scrollRow = current * 10;
    }
    this.setState({
      pagination: pageinfo
    });
  }
  //分页改变事件
  _PaginChange = (page) => {
    if (this.props.model)
      this.props.model.setPageIndex(page);
  }
  /*页大小改变*/
  onShowSizeChange = (current, size) => {
    if (this.props.model)
      this.props.model.setPageSize(size);
  }
  setPage = (pagination, isPage) => {
    if (isPage && pagination.total !== 0) {
      let sumData = this.state.sumData;
      let columns = this.columns;
      let showSums = [];
      if (sumData.length > 0) {
        for (var key in sumData[0]) {
          if (!columns[key]) continue;
          if (sumData[0][key] == 0) continue;
          showSums.push(
            <Col span={1} style={{ fontSize: '18px' }}>
              {columns[key].cCaption}：{sumData[0][key]}
            </Col>
          )
          if (showSums.length > 2) {
            break;
          }
        }
      }
      let selectOptions = [{ "value": 10, "text": 10 }, { "value": 20, "text": 20 }, { "value": 30, "text": 30 }, { "value": 40, "text": 40 }, { "value": 50, "text": 50 }];
      let selectOptionsControl = selectOptions.map((item, index) => {
        return <Select.Option key={item.value} text={item.text}>{item.text}</Select.Option>
      });
      return (
        <div className='pagination-new'>
          <Pagination showQuickJumper showSizeChanger pageSizeOptions={['10', '20', '30', '50', '80', '100', '65536']} showTotal={total => `共${total}条`} size="small" total={pagination.total} current={pagination.current} pageSize={pagination.pageSize} onShowSizeChange={this.onShowSizeChange} onChange={this._PaginChange} />
        </div>
      );
    }
  }

  _setFooter = (cellProps) => {
    let column = this.columns;
    if (this.GridProps.showAggregates || this.GridProps.showAggregates == 'local') {
      if (this.GridProps.showCheckBox) {
        if (cellProps.columnKey === 'CheckBox') {
          return (
            <div className="fixedDataTable-footer-title">
              <div className='public_fixedDataTableCell_cellContent'> 合计</div>
            </div>
          )
        }
      } else if (this.GridProps.showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') {
          return (
            <div className="fixedDataTable-footer-title">
              <div className='public_fixedDataTableCell_cellContent'> 合计</div>
            </div>
          )
        }
      } else if (this.ColIndexs[cellProps.columnKey] === 0) {
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent'> 合计</div>
          </div>
        )
      }
      if (cellProps.columnKey == 'Setting') {
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent'></div>
          </div>
        )
      }
      let sumData = this.state.sumData;
      if (sumData.length > 0) {
        let data = this.dataList;
        let sum = 0;
        for (var key in sumData[0]) {
          if (key === cellProps.columnKey) {
            sum = this._getDecimal(this.columns[key], sumData[0][key]);
            return (
              <Cell>
                <div style={{ "padding": "12px 10px", lineHeight: "14px" }} className="textCol" >
                  {sum}
                </div>
              </Cell>
            )
          }
        }
      } else {
        if (this.GridProps.showAggregates == 'local') {
          if (column[cellProps.columnKey].bNeedSum) {
            let data = this.dataList;
            let sum = 0;
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                let val = data[i][cellProps.columnKey];
                val = val ? val : 0;
                sum = getMultiplication(sum, parseFloat(val), 'add');
              }
            }
            sum = this._getDecimal(this.columns[cellProps.columnKey], sum);
            return (
              <Cell>
                <div style={{ "padding": "12px 10px", lineHeight: "14px" }} className="textCol" >
                  {sum}
                </div>
              </Cell>
            )
          }
        } else {
          return (
            <Cell><div style={{ "padding": "12px 10px", lineHeight: "14px" }} className="textCol" ></div></Cell>
          )
        }
      }
    } else if (this.GridProps.showSubtotal) {
      if (cellProps.columnKey == 'Setting') {
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent'></div>
          </div>
        )
      }
      if (this.GridProps.showCheckBox) {
        if (cellProps.columnKey === 'CheckBox') {
          return (
            <div className="fixedDataTable-footer-title">
              <div className='public_fixedDataTableCell_cellContent'> 小计</div>
            </div>
          )
        }
      } else if (this.GridProps.showRowNo) {
        if (cellProps.columnKey === 'GridRowNo') {
          return (
            <div className="fixedDataTable-footer-title">
              <div className='public_fixedDataTableCell_cellContent'> 小计</div>
            </div>
          )
        }
      } else if (this.ColIndexs[cellProps.columnKey] === 0) {
        return (
          <div className="fixedDataTable-footer-title">
            <div className='public_fixedDataTableCell_cellContent'> 小计</div>
          </div>
        )
      }
      if (column[cellProps.columnKey].bNeedSum) {
        let data = this.dataList;
        let sum = 0;
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            let val = data[i][cellProps.columnKey];
            val = val ? val : 0;
            sum = sum + val;
          }
        }
        return (
          <Cell>
            <div style={{ "padding": "12px 10px", lineHeight: "14px" }} className="textCol" >
              {sum}
            </div>
          </Cell>
        )
      }
    }
  }
  _getDecimal = (col, sum) => {
    let NumPoint = col.iNumPoint;
    /*谓词变量支持系统参数*/
    let cFormatData = col.cFormatData;
    try {
      if (!cFormatData || cFormatData == '') {
        cFormatData = {};
      } else {
        cFormatData = JSON.parse(cFormatData);
      }
    } catch (e) {
      cb.utils.alert('数量/金额/单价，预制错误！', 'error');
    }
    let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
    let controlType = col.cControlType ? col.cControlType.trim().toLocaleLowerCase() : '';
    if (controlType === 'money') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.amountofdecimal;
    } else if (controlType === 'price') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.monovalentdecimal;
    } else if (controlType === 'inputnumber') {
      if (decimal)
        NumPoint = decimal;
      else
        if (!NumPoint || NumPoint == '') NumPoint = 0;

    } else {
      NumPoint = null;
    }
    if (!isNaN(sum) && NumPoint) {
      sum = Number(sum);
      sum = getRoundValue(sum, NumPoint);
    }
    return sum;
  }
  onScrollEnd = (scrollx, scrolly, hideRows) => {
    let vm = this.props.model && this.props.model.getParent();
    if (vm) {
      vm.execute('tableScroll', { isBegin: false, x: scrollx, y: scrolly })
    }
    let rowCount = this.dataList.length;
    if (!this.GridProps.isPagination) return;
    if ((this.showRows + hideRows - 1) == rowCount || (this.showRows + hideRows - 1) == (rowCount - 1) || (this.bodyHeight + scrolly) == rowCount * this.rowheight) {
      let pagination = this.state.pagination;
      let newSize = pagination.current + 1;
      let pageCount = pagination.total / pagination.pageSize;
      pageCount = Math.ceil(pageCount);
      if (newSize > pageCount) return;
      if (this.props.model)
        this.props.model.setPageIndex(pagination.current + 1);
    }
  }
  // onRowTouchEnd=(e,isEnd)=>{
  //     if (isEnd == 1) {
  //         let pagination = this.state.pagination;
  //         let newSize = pagination.current + 1;
  //         let pageCount = pagination.total/pagination.pageSize;
  //         pageCount = Math.ceil(pageCount);
  //         if (newSize > pageCount) return;
  //         if (this.props.model)
  //             this.props.model.setPageIndex(pagination.current + 1);
  //     }
  // }
  // 悬浮按钮
  rowHeightGetter = (index) => {
    if (this.state.openContentHeight && this.contentHeight && this.contentHeight[index]) { // 开启根据内容计算row高度时
      return this.contentHeight[index]
    }
    return this.rowheight;
  }
  getEmptyData = () => {
    let data = this.dataList;
    if (data.length) return;
    const text = this.state.showSearch ? '搜索无结果' : '暂时没有数据哦~';
    const icon = this.props.emptyIcon || 'nodata';
    let height = 280;
    //const defineStyle = cb.config.getDefineStyle();
    const { tableNoDataHeight, tableNoDataRowCount } = this.props;
    // if (defineStyle.emptyTableHeight) {
    //   height = defineStyle.emptyTableHeight;
    // } else 
    if (tableNoDataHeight) {
      height = tableNoDataHeight;
    } else if (tableNoDataRowCount) {
      height = this.rowheight * tableNoDataRowCount;
    }
    //let className = noDataModule.tableNodata;
    if (height < 110) {
      className += ' tableNoDateHideIcon';
    }
    // if (this.isGroup) {
    //   className += ` ${noDataModule.rptTableNodata}`
    // }
    return <div className='table-nodata'><SvgIcon type={icon} />{text}</div>
    
  }
  getStringLength = (str) => {
    if (!str) str = '';
    let realLength = 0, len = str.length, charCode = -1;
    for (var i = 0; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128) {
        realLength += 1;
      } else {
        realLength += 2;
      }
    }
    return realLength
  }
  getFooterHeight = () => {
    let style = this.state.style || {};
    let footerHeight = this.props.footerHeight || 0;
    if (style.rowheight) this.rowheight = parseFloat(style.rowheight);

    if ((this.GridProps.showAggregates == 'local') || (this.GridProps.showAggregates == true && this.state.sumData.length > 0))
      footerHeight += this.rowheight;
    if (this.GridProps.showSubtotal)
      footerHeight += this.rowheight;
    if (this.dataList.length == 0) footerHeight = 0;
    return footerHeight;
  }
  getGridHeight = (footerHeight) => {
    let gridHeight = this.props.height || 600;
    let scrollXWidth = (this.totalWidth > (this.props.width || 1100) ? 17 : 2);
    if (cb.utils.isEmpty(footerHeight)) footerHeight = this.getFooterHeight();
    /*交班--根据传入rowcount  动态渲染高度*/
    const calcHeightByRowCount = this.state.calcHeightByRowCount;
    // 全屏显示---列表页
    if ((this.props.fullHeight && !this.props.hidePane) && !this.nidAnduitype.nid && !this.nidAnduitype.uitype) {
      const height = this.getTableOffsetParent();
      if (height > 170) {
        gridHeight = height;
        return gridHeight;
      }
    }
    if (calcHeightByRowCount) {
      gridHeight = this.rowheight * calcHeightByRowCount + (this.headerHeight || 40) + footerHeight + 8;
      if (this.colsWidth > this.state.gridWidth) gridHeight += 10;
      if (gridHeight < 200) gridHeight = 200;
    }
    if (this.props.listHeaderHeight || this.props.adaptiveHeight) {
      let gHeight = this.rowheight * this.dataList.length + (this.headerHeight || 40) + (this.groupHeaderHeight || 0) + footerHeight + scrollXWidth;
      if (gridHeight > gHeight) gridHeight = gHeight;
      if (gridHeight < 170 && this.dataList.length == 0) gridHeight = 170;
    }
    if (this.dataList.length == 0 && !this.props.height) gridHeight = 200;
    if (this.dataList.length == 0 && gridHeight < 230) gridHeight = 230;
    if (this.props.autoHeight === false) gridHeight = this.props.height;
    return gridHeight;
  }
  // 判断是否有底部栏
  isContainBottomToolbar = () => {
    const tableDom = this.fixedTable && this.fixedTable._divRef;
    let height = 0;
    if (tableDom) {
      let parent = cb.dom(tableDom).parents('.wui-tabs-tabpane-active.mdf-bill-tabpane')[0];
      if (!parent && this.parentDom.classList.contains('mdf-modal-body')) {
        parent = this.parentDom;
      }
      if (parent) {
        // 可能有多个bottom-toolbar
        const toolbar = parent.querySelectorAll('.bottom-toolbar');
        if (toolbar.length > 0) {
          for (let i = 0; i < toolbar.length; i++) {
            if (toolbar[i] && !toolbar[i].classList.contains('hide')) {
              // 按钮组隐藏
              height = toolbar[i].clientHeight;
              break;
            }
          }
        }
        // 按钮组隐藏
        // if (toolbar && !toolbar?.classList?.contains('hide')) height = toolbar.clientHeight;
        const bottomDom = parent.querySelector('.tab-bottom-txt');
        if (bottomDom && !bottomDom.classList.contains('hide')) height += bottomDom.clientHeight;
      }
    }

    return height;
  }
  // 获取表格距离顶部的高度，直到DOM的类名是iframeConcent，层层offsetTop值相加
  getTableOffsetParent = () => {
    let gridHeight = 180;
    let top = 0;
    const tableDom = this.refs.tableCon;
    if (tableDom) {
      top = tableDom.offsetTop;
      let parentDom = tableDom.offsetParent;
      while (parentDom && !parentDom.classList.contains('iframeConcent') && !parentDom.classList.contains('mdf-modal-body')) {
        top += parentDom.offsetTop;
        parentDom = parentDom.offsetParent
      }
      if (parentDom && (parentDom.classList.contains('iframeConcent') || parentDom.classList.contains('mdf-modal-body'))) {
        this.parentDom = parentDom;
        if (parentDom.classList.contains('mdf-modal-body') && parentDom.style.maxHeight && !parentDom.classList.contains('fadeRightToLeft')) {
          gridHeight = parseInt(parentDom.style.maxHeight) - top;
        } else {
          gridHeight = parentDom.clientHeight - top;
        }
      } else if (cb.utils.getPopoverModalContainer(tableDom)) {
        gridHeight = cb.utils.getPopoverModalContainer(tableDom).clientHeight - top
      } else {
        this.parentDom = document.body;
        gridHeight = document.body.clientHeight - top;
      }
      if (this.props.style && this.props.style.percentHeight) {
        const tableDoms = this.parentDom.querySelectorAll('.meta-table')
        for (let i = 0; i < tableDoms.length; i++) {
          if (tableDoms[i].id !== tableDom.id) {
            gridHeight += tableDoms[i].clientHeight;
          } else {
            break;
          }
        }
      }
      // 如果包含groupcontainer(section)再减去6
      if (this.parentDom.querySelector('section') && !(this.state.style && this.state.style.cardNav)) {
        gridHeight -= 9;
      }
      const hasBottomToolbar = this.isContainBottomToolbar();
      if (hasBottomToolbar) {
        gridHeight -= hasBottomToolbar;
      }
      const modalDom = cb.dom(tableDom).parents('.mdf-modal') || [];
      const billType = this.props.model.getParent().getParams().billType.toLowerCase()
      if (cb.__DIWORK_INTEGRATION_MODE__ === 'none' && !modalDom.length) {
        if (billType != 'voucher' && billType != 'archive') {
          gridHeight -= 8;
        }
      }
      if (!(this.props.subTableFullHeight || this.props.hidePane) && !(this.state.style && this.state.style.cardNav)) gridHeight -= 2; // 空值的时候有个2像素的高度差
      // const isCacheSelectedRows = this.isCacheSelectedRows();
      // modal中点击表格跳转到其他页面时获取不到modal的DOM了
      if (!parentDom && this.parentDom.classList.contains('mdf-modal-body') && this.gridHeight) {
        gridHeight = this.gridHeight;
      }
    }
    return gridHeight;
  }
   /**
  * 渲染表格的卡片形态
  * @returns ReactDOM
  */
   setChooseTable = (value) => {
    this.GridProps.isChooseTable = value;
    this.setState({
      chooseTableMode: this.GridProps.isChooseTable ? 'list' : 'card'
    });
  }
  setTableCardCols = () => { // 设置表格再card展示下的宽度
    clearTimeout(this.tableCardTimter)
    this.tableCardTimter = setTimeout(() => {
      const tableCardWith = this.tableCardCont.clientWidth;
      let cardCol = 0
      if (tableCardWith >= 1920) {
        cardCol = 5
      } else if (tableCardWith >= 1360) {
        cardCol = 4
      } else if (tableCardWith >= 1020) {
        cardCol = 3
      } else if (tableCardWith >= 600) {
        cardCol = 2
      } else {
        cardCol = 1
      }
      if (this.state.cardCol != 1 && cardCol === 1) {
        return
      }
      cardCol !== this.state.cardCol && this.setState({ cardCol })
    }, 800);
  }
  getShowCardContainer = (cardType) => {
    //const { isWidget = false } = this.props.model.getRootParent().getParams() || {};
    if (this.state.style && this.state.style.cardSetting) {
      if (this.props.meta.containers.length) {
        const listCardContent = this.props.meta.containers.filter((x) => x.cControlType.toLowerCase() === 'listcard')
        const extendCardCotent = this.props.meta.containers.filter((x) => x.cControlType.toLowerCase() !== 'toolbar')
        const container = listCardContent.length && listCardContent || extendCardCotent
        const containerArr = []
        for (let i = 0; i < container.length; i++) {
          containerArr.push(
            parseContainer(container[i], this.props.model.getParent(), null, null, null, null, null, null, {
              isWidget: false,
              action: this.action,
              actionState: this.actionState,
              dataList: this.dataList,
              checkBox: this.GridProps.showCheckBox,
              selectAll: this.allSelect,
              indeterminate: this.props.indeterminate,
              ActionClick: this.ActionClick,
              onRowClick: this._onRowClick,
              cardCol: this.state.cardCol || 0,
              containers: container
            })
          )
        }
        return containerArr
      }
    } else {
      return <Row
        model={this.props.model}
        meta={this.props.meta}
        isWidget={false}
        action={this.action}
        actionState={this.actionState}
        dataList={this.dataList}
        checkBox={this.GridProps.showCheckBox}
        type={cardType}
        width={this.props.width}
        selectAll={this.allSelect}
        indeterminate={this.indeterminate}
        ActionClick={this.ActionClick}
        onRowClick={this._onRowClick}
        cardCol={this.state.cardCol || 0}
      ></Row>
    }
  }
  render() {
    const {visible, chooseTableMode} = this.state;
    let gridClassName = '';
    let footerHeight = this.getFooterHeight();
    let gridHeight = this.getGridHeight(footerHeight);
    let emptyData = this.getEmptyData();
    const style = this.state.style || {};
    if (visible) gridClassName = 'hide';
    this.gridHeight = Math.round(gridHeight);
    if (this.props.model.getCache('lazyLoadByPage')) {
      this.gridHeight > 100 && (this.gridHeight -= 50)
    }
    if (cb.isInTouchReport(this.props.model && this.props.model.getParent())) {
      if (_.isEmpty(emptyData) == true) {
        let tmp = document.getElementsByClassName("container_TouchRptCls");
        if (tmp && tmp[0].clientHeight)
          gridHeight = tmp[0].clientHeight + 2;//加两个像素，避免拖到顶部后，显示双线条
        else
          gridHeight = document.body.clientHeight;
      }
      else {
        gridHeight = 313;
      }
    }
    if (visible) gridClassName = 'hide';
    console.log('scrollRow-------' + this.scrollRow + "  gridHeight = " + gridHeight);
    return (
      <div id={this.tableGuid || ''}  className={`meta-table ${gridClassName} ${this.props.tableClass || ''}` + ' touch-grid'} ref='tableCon'>
        <Tabs className='meta-container' activeKey={chooseTableMode} type='card' hideAdd animated={false} style={{ marginTop: 0 }}>
        <TabPane key='list' tab='List'>
        <Row>
          <Table
            rowHeight={this.rowheight}
            overflowY={'auto'}
            overflowX={'auto'}
            onScrollStart={this.onScrollStart}
            onScrollEnd={this.onScrollEnd}
            // onRowTouchEnd={this.onRowTouchEnd}
            footerHeight={footerHeight}
            onRowTouchMove={this.onRowTouchMove}
            headerHeight={this.headerHeight || 40}
            groupHeaderHeight={this.groupHeaderHeight || 0}
            rowsCount={this.dataList.length}
            width={cb.isInTouchReport(this.props.model && this.props.model.getParent()) ? this.state.gridWidth : this.state.gridWidth}
            height={gridHeight}
            isColumnResizing={false}
            onRowClick={this._onRowClick}
            rowClassNameGetter={this.rowClassNameGetter}
            rowHeightGetter={this.rowHeightGetter}
            scrollToRow={this.scrollRow}
            scrollToColumn={this.scrollCol}
            touchScrollEnabled
          >
            {this.state.columnset}
          </Table>
          {emptyData}
        </Row>
        </TabPane>
          <TabPane key='card' tab='Card'>
            <div className={(style && style.cardNav) ? 'cardNavContent' : 'table-card-container'} ref={e => { this.tableCardCont = e }} style={{ height: this.gridHeight }}>
              {(style && style.cardNav) ? <div className={'cardNav ' + style.cardNavClass} ref='tableCardScroll' onScroll={e => this.debounce(this.onScroll(e), 3000)}>{this.getShowCardContainer('nav')}</div> : this.getShowCardContainer()}
              {emptyData}
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
  debounce = (fn, delay) => {
    let timer = null;
    return function() {
      if (timer) clearTimeout(timer);
      const context = this;
      const args = arguments;
      timer = setTimeout(() => fn.apply(context, args), delay);
    }
  }

  onScroll = e => {
    if (!this.GridProps.isPagination) return;
    const scrollTop = e.target.scrollTop;
    const cardScroll = this.refs.tableCardScroll;
    const scrollHeight = cardScroll.scrollHeight;
    const clientHeight = cardScroll.clientHeight;
    if (scrollTop >= scrollHeight - clientHeight - 200) {
      const pagination = this.state.pagination;
      const newSize = pagination.current + 1;
      let pageCount = pagination.total / pagination.pageSize;
      pageCount = Math.ceil(pageCount);
      if (newSize > pageCount) return;
      if (this.props.model)
        this.props.model.setPageIndex(pagination.current + 1);
    }
  }
  onScrollStart = (x, y) => {
    let vm = this.props.model && this.props.model.getParent();
    if (vm) {
      vm.execute('tableScroll', { isBegin: true, x, y })
    }
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/grid-touch/Table.jsx